import { EmployeeNameSearchInfo, EmployeeWithRole } from '../../types'

export const roleColor = (role: string): 'cyan' | 'lime' => {
  if (role.includes('ADMIN')) {
    return 'cyan'
  } else if (role.includes('READONLY')) {
    return 'lime'
  }
  return 'lime' // fallback
}

export const convertEmployeeFromSearch = (e: EmployeeNameSearchInfo): EmployeeWithRole => {
  return {
    id: e.id,
    firstName: e.legalFirstName,
    lastName: e.legalLastName,
    companyName: e.companyName,
    buName: e.buName,
    hrRoleOfUser: [],
    assignedTo: [],
    hasDownloaderRole: false,
  } as EmployeeWithRole
}

export const convertEmployeeToSearch = (e: EmployeeWithRole): EmployeeNameSearchInfo => {
  return {
    id: e.id,
    legalFirstName: e.firstName,
    legalLastName: e.lastName,
    companyName: e.companyName,
    buName: e.buName,
  } as EmployeeNameSearchInfo
}
